import type * as React from "react";

// eslint-disable-next-line no-restricted-imports
import type { AppMenuButtonProps } from "@1js/acui-button/lib/Next";
// eslint-disable-next-line no-restricted-imports
import { useAppMenuButton } from "@1js/acui-button/lib/Next";

import type { RibbonMenuButtonState } from ".";
import { useRibbonControlLabel } from "../../RibbonButton/next";
import { useRibbonMenuButtonState } from "./useRibbonMenuButtonState";
import { useLargeRibbonMenuButtonLabel } from "../../../../../hooks";
import { useCommonRibbonButtonLabelClassNames } from "../../next/commonRibbonButtonStyles.styles";
import { useRibbonMenuButtonTextContainerClassNames } from "./useRibbonMenuButtonStyles.styles";

export const useRibbonMenuButton = (
  props: AppMenuButtonProps,
  ref: React.Ref<HTMLButtonElement>
) => {
  const { label, size, onRenderText } = props;

  // Custom label styles for ribbon menu buttons
  const styles = useRibbonMenuButtonTextContainerClassNames(size);
  const ribbonControlLabel = useRibbonControlLabel(
    label,
    size,
    onRenderText,
    useCommonRibbonButtonLabelClassNames(size, styles)
  );

  const state = useAppMenuButton(
    {
      ...props,
      // Render large menu button label if size = large, otherwise render the regular ribbon control label
      children: useLargeRibbonMenuButtonLabel(props) || ribbonControlLabel,
    },
    ref
  ) as RibbonMenuButtonState;

  useRibbonMenuButtonState(props, state);

  return state;
};
